"use client";
import dynamic from "next/dynamic";
export * from "./alertAtom";
export const Alert = dynamic(() => import("./Alert"));
export * from "./useAlert";
